import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/violin-plot/pages/CalculatorPage";

export const Route = createFileRoute("/violin-plot")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/violin-plot",
      title: m.violin_meta_title(),
      description: m.violin_meta_description(),
      toolName: m.violin_tool_name(),
      faqs: [
        { q: m.violin_faq_q1(), a: m.violin_faq_a1() },
        { q: m.violin_faq_q2(), a: m.violin_faq_a2() },
        { q: m.violin_faq_q3(), a: m.violin_faq_a3() },
        { q: m.violin_faq_q4(), a: m.violin_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
